import React from 'react';
import {Box, Modal} from "@mui/material";
import {Button} from "../../common/button";
import {useTranslation} from "react-i18next";
import {Text} from "../../common/text";

export const ConfirmModal = ({
  header,
  headerProps,
  body,
  bodyProps,
  footer,
  footerProps,
  openModal,
  closeModal,
  acceptance,
  stylePopup = '',
  submitProps = {},
  closeBackdropClick=false,
  styles={},
  subTitle,
}) => {
  const {t} = useTranslation()
  return (
    <>
      <Modal
        open={openModal}
        onClose={closeBackdropClick ? false : closeModal}
      >
        <Box className={`confirm-popup ${stylePopup}`} style={styles}>
          <div>
            {!!header && (
              <div
                {...headerProps}
                className={`confirm-popup__header ${headerProps?.className || ''}`}
              >
                {header}
              </div>
            )}
            {
              !!subTitle && (
                  <Text color={'#4B4B4B'}>{subTitle}</Text>
              )
            }
            {!!body && (
              <div
                {...bodyProps}
                className={`confirm-popup__body ${bodyProps?.className || ''}`}
              >
                {body}
              </div>
            )}
            {!!footer && (
              <div
                {...footerProps}
                className={`confirm-popup__group-btn ${footerProps?.className || ''}`}
              >
                <Button onClick={closeModal}
                        appearance={'ghost'}
                        className={'confirm-popup__dismiss'}
                        style={{width: footer?.cancel?.width ?? 110}}
                        size={'sm'}
                >{t(footer?.cancel?.title) || t('cancel')}</Button>
                <Button onClick={acceptance}
                        className={'confirm-popup__save'}
                        style={{width: footer?.acceptance?.width ?? 110}}
                        size={'sm'}
                        {...submitProps}
                >{t(footer?.acceptance?.title) || t('confirm')}</Button>
              </div>
            )}
          </div>
        </Box>
      </Modal>
    </>
  );
}